import React from 'react'
import PropTypes from 'prop-types'
import DatePicker from 'react-datepicker'
import moment from 'moment'

class CngDatePicker extends React.Component {
  getValidDate = value => {
    if (!value) {
      return null
    }

    if (moment.isMoment(value)) {
      return value.isValid() ? value.toDate() : null
    }

    if (value instanceof Date) {
      return Number.isNaN(value.getTime()) ? null : value
    }

    const parsedDate = moment(value)
    return parsedDate.isValid() ? parsedDate.toDate() : null
  }

  handleBlur = () => {
    const { onBlur, field } = this.props
    onBlur(field.name)
  }

  handleChange = event => {
    const { onChange, field } = this.props
    onChange(field.name, event || '')
  }

  render () {
    const props = this.props
    return (
      <DatePicker
        {...props}
        fixedHeight
        onChange={this.handleChange}
        onBlur={this.handleBlur}
        selected={this.getValidDate(props.mydate)}
        minDate={this.getValidDate(props.minDate)}
        maxDate={this.getValidDate(props.maxDate)}
        className={
          props.invalid
            ? 'date-picker is-invalid form-control'
            : 'date-picker form-control'
        }
        calendarClassName='cng-datepicker-calendar'
        disabled={props.disabled}
        readOnly={props.readOnly || false}
        disabledKeyboardNavigation
        isClearable={true}
      />
    )
  }

  static propTypes = {
    onBlur: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    field: PropTypes.object.isRequired,
    mydate: PropTypes.object,
    minDate: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    maxDate: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    invalid: PropTypes.bool,
    disabled: PropTypes.bool,
    readOnly: PropTypes.bool
  }
}

export default CngDatePicker
